export default __webpack_public_path__ + "static/media/logotipo.e6c5fc02.svg";